var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustinLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 40,
    viewBox: "0 0 123 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 9V28H31L33 31H22V9H25ZM32 0H22V3H32C34.757 3 37 5.243 37 8V32C37 34.757 34.757 37 32 37H7.99999C5.24299 37 3 34.757 3 32V8C3 5.243 5.24299 3 7.99999 3H11V0H7.99999C3.582 0 0 3.582 0 8V32C0 36.418 3.582 40 7.99999 40H32C36.418 40 40 36.418 40 32V8C40 3.582 36.418 0 32 0ZM18 0H15V3H18V0ZM15 9V28H6.99999L8.99999 31H18V9H15Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 14V7H65V14C65 16 66 16.4 67 16.4C68 16.4 69 16 69 14V7H71V14C71 17.314 69.44 18.4 67 18.4C64.56 18.4 63 17.362 63 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18H94V9H91V7H99V9H96V18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 8V7H105V8H107V17H105V18H110V17H108V8H110Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122 18L117 9V18H116V7H117L122 16V7H123V18H122Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 22H53V31H58V33H51V22Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105 22H107V31H112V33H105V22Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63 22H70.4V24H65V27H68V29H65V31H71V33H63V22Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.272 31H92.726L91.998 33H89.998L93.998 22H95.998L99.998 33H97.998L97.27 31H97.272ZM94.998 24.6L93.454 29H96.544L94.998 24.6Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7V14.174C55 16.144 54.182 16.56 53.222 16.56C52.334 16.56 51.674 16.162 51.256 15.374L49.6 16.2C50.302 17.616 51.654 18.4 53.222 18.4C54.936 18.4 57 17.552 57 14.382V7H55Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.38 11.246C80.104 10.854 79 10.512 79 9.68199C79 8.89999 79.682 8.45999 80.784 8.45999C81.886 8.45999 82.566 8.90599 82.952 9.62599L84.726 8.73799C84.192 7.50399 82.888 6.60199 80.924 6.60199C78.352 6.60199 77 8.00399 77 9.66599C77 11.834 78.86 12.47 80.61 13.024C81.992 13.464 83.4 13.872 83.4 14.964C83.4 16.056 82.426 16.544 81.168 16.544C79.91 16.544 78.984 15.866 78.466 14.87L76.6 15.802C77.334 17.44 78.966 18.402 81.098 18.402C83.512 18.402 85.4 17.164 85.4 14.964C85.4 12.552 83.164 11.834 81.38 11.248V11.246Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85 27H81V29H83V31.4H81.404C80.648 31.4 79.732 31.138 79.332 30.548C78.862 29.856 78.604 28.772 78.604 27.5C78.604 26.228 78.862 25.144 79.332 24.452C79.732 23.864 80.246 23.6 81.004 23.6C81.762 23.6 82.272 23.862 82.674 24.452C82.772 24.596 82.86 24.756 82.938 24.932L84.724 24.038C84.034 22.562 82.81 21.6 81.004 21.6C78 21.6 76.604 24.242 76.604 27.5C76.604 30.758 78 33.4 81.004 33.4H85V27Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustinLogoFull);
export default __webpack_public_path__ + "static/media/justin-logo-full.cc3e21c8d431f414aea2a1b8c403ec0e.svg";
export { ForwardRef as ReactComponent };